<template>
  <div>
    <v-dialog v-model="showWindow" scrollable max-width="850px" persistent>
      <v-card
        :loading="isLoading || savingInProgress || !fetched || !orderFetched"
      >
        <v-card-actions>
          <h3 class="pl-2">
            {{ $t("viewOrdersForm.receipt") }}
            <span v-if="presenter===null"> {{ $t("viewOrdersForm.receipt_std_subtitle") }}</span>

            <span v-if="presenter==='OrderConcatenatedRepairtimesWithParts'">
              <v-icon>mdi-vector-union</v-icon>
              {{ $t("viewOrdersForm.receipt_concat_subtitle") }}
            </span>
            <span v-if="presenter!==null && presenter!=='OrderConcatenatedRepairtimesWithParts'"> {{ $t("viewOrdersForm.unknown_type_of_receipt") }}</span>
          </h3>
          <v-spacer></v-spacer>
          <v-btn icon @click="showWindow = false">
            <v-icon>fa-times</v-icon>
          </v-btn>
        </v-card-actions>
        <v-divider></v-divider>
        <v-card-text class="pa-4" v-if="!isOrderStatusRightForPrintReceipt">
          {{ $t("viewOrdersForm.can_print_with_status") }} "{{
            $t(`common.orderSystemStatusNames.${canPrintWithStatus}`)
          }}"
        </v-card-text>
        <v-card-text
          class="pa-4"
          v-if="isOrderStatusRightForPrintReceipt && hasError === false"
        >
          <v-form ref="receiptForm">
            <h1>
              {{ $t("common.total_sum") }}:
              {{ formatCurrency(parseFloat(order.total_sum).toFixed(2)) }}
            </h1>
            <kkm-select
              class="pt-5"
              @setNumDevice="(num) => (kkmNumDevice = num)"
            ></kkm-select>
            <v-radio-group v-model="typeOfPayment">
              <h3 class="mb-2">{{ $t("payments.type") }}</h3>
              <v-radio
                v-for="typeOP in listTypesOfPayment"
                :key="typeOP"
                :label="$t('payments.kkm.' + typeOP)"
                :value="typeOP"
              ></v-radio>
            </v-radio-group>
            <v-btn
              class="mr-2"
              elevation="0"
              :title="$t('common.other_receipts')"
              @click="
                isVisibleReceiptsAdditionalWindow =
                  !isVisibleReceiptsAdditionalWindow
              "
              ><v-icon color="warning">mdi-receipt</v-icon></v-btn
            >
            <v-btn
              :disabled="
                !typeOfPayment || isLoading || savingInProgress || !fetched
              "
              color="success"
              @click="printReceiptSaleOrArrival(order)"
              @keyup.enter="printReceiptSaleOrArrival(order)"
              elevation="0"
            >
              <v-icon v-if="presenter==='OrderConcatenatedRepairtimesWithParts'">mdi-vector-union</v-icon>
              {{ $t("viewOrdersForm.print_sale_receipt") }}
            </v-btn>
            <v-list
              v-if="receipts.length"
              class="overflow-y-auto"
              style="max-height: 300px"
            >
              <v-list-item>
                <h3>{{$t("windowReceipt.printed_receipts")}}</h3>
              </v-list-item>
              <v-list-item v-for="receipt in receipts" two-line>
                <v-list-item-content class="py-0">
                  <v-list-item-title
                    >{{ receipt.created_at | moment("DD.MM.YYYY HH:mm") }}
                    {{ $t("common.total_sum") }}: {{ formatCurrency(receipt.sum) }};

                    {{ receipt_types[receipt.receipt_type] }}
                    {{
                      receipt.type_of_payment === "electronic"
                        ? $t("windowReceipt.payed_by_card")
                        : $t("windowReceipt.cash")
                    }}
                    <span class="red--text" v-if="receipt.is_canceled == 1"
                      >{{$t("windowReceipt.canceled")}}</span
                    >
                  </v-list-item-title>
                  <v-list-item-subtitle
                    v-if="
                      receipt.receipt_type === 0 && receipt.is_canceled != 1
                    "
                  >
                    <v-btn
                      :disabled="isLoading || savingInProgress || !fetched"
                      text
                      v-if="receipt.card_payment_data"
                      @click="printReceiptReturnOfSaleOrArrival(receipt)"
                      color="red"
                      >{{ $t("windowReceipt.cancel_and_return_money_to_card") }}</v-btn
                    >
                    <v-btn
                      :disabled="isLoading || savingInProgress || !fetched"
                      text
                      v-else="receipt.card_payment_data"
                      @click="printReceiptReturnOfSaleOrArrival(receipt)"
                      color="red"
                      >Отменить</v-btn
                    >
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-divider class="mt-4"></v-divider>
            <v-card-actions class="pa-0 mx-0">
              <v-spacer></v-spacer>
              <v-btn
                class="mr-2 mt-4 white--text"
                color="red"
                elevation="0"
                @click="showWindow = false"
              >
                {{ $t("common.cancel") }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <receipts-additional-window
      :show="isVisibleReceiptsAdditionalWindow"
      @hide="isVisibleReceiptsAdditionalWindow = false"
    ></receipts-additional-window>
  </div>
</template>

<script>
import {
  KKMPrintReceipt,
  KKMListDevices,
  KKMGetDataKKT,
  KKMCancelPaymentByPaymentCard,
  KKMPayByPaymentCard,
} from "@/plugins/kkm-server-api";
import { mapFields } from "vuex-map-fields";
import CommonMixin from "@/mixins/common";
import ReceiptsAdditionalWindow from "../receipts_additional/ReceiptsAdditionalWindow";
import KkmSelect from "../receipts_additional/KkmSelect";

export default {
  name: "OrderReceiptWindow",
  components: { KkmSelect, ReceiptsAdditionalWindow },
  mixins: [CommonMixin],
  props: {
    /**
     * presenter - параметр представления с которым будет получен заказ(например "OrderConcatenatedRepairtimesWithParts")
     */
    presenter: null,
    show: {
      type: Boolean,
      default: false,
    },
    orderId: {
      type: Number,
    },
  },
  data: () => ({

    kkmNumDevice: -1,
    isVisibleReceiptsAdditionalWindow: false,
    canPrintWithStatus: process.env.VUE_APP_ORDER_STATUS_FOR_RECEIPT_PRINT,
    listTypesOfPayment: ["cash", "electronic"],
    typeOfPayment: null,
    receipt_types: {
      0: "продажа/приход;", //SALE_OR_ARRIVAL
      1: "возврат продажи/прихода;", //RETURN_OF_SALE_OR_ARRIVAL
      2: "корректировка продажи/прихода;",
      10: "покупка/расход;",
      11: "возврат покупки/расхода;",
      12: "корректировка покупки/расхода;",
    },
  }),
  methods: {
    getReceipts() {
      this.$store.dispatch("receipts/get", this.order.id);
    },
    /**
     * Чек отмены продажи
     * @param receipt
     * @returns {Promise<void>}
     */
    async printReceiptReturnOfSaleOrArrival(receipt) {
      let typeOfPayment = receipt.type_of_payment;
      let receiptNumber = new Date().getTime();
      if (receipt.receipt_type === 0) {
        let receiptType = 1; //1 – возврат продажи/прихода;
        let options = receipt.options;
        options.numDevice = this.kkmNumDevice;
        options.receiptType = 1;
        if (receipt.card_payment_data) {
          // RRNCode из операции эквайринга. Только для отмены оплаты! Для Оплаты или возврата оплаты не заполнять!
          options.RRNCode = receipt.card_payment_data.RRNCode;
          options.AuthorizationCode =
            receipt.card_payment_data.AuthorizationCode;
          options.CardNumber = receipt.card_payment_data.CardNumber;
          options.ReceiptNumber = receipt.card_payment_data.ReceiptNumber;
        }

        this.printReceipt(
          this.kkmNumDevice,
          typeOfPayment,
          receiptType,
          receiptNumber,
          options,
          receipt.receipt_lines,
          receipt.sum,
          receipt.order_id,
          receipt.id
        );
      }
    },
    /**
     * Чек продажи
     * @param order
     * @returns {Promise<void>}
     */
    async printReceiptSaleOrArrival(order) {
      let receiptNumber = new Date().getTime();
      let receiptType = 0; //продажа/приход

      let typeOfPayment = this.typeOfPayment;
      const options = {
        //Если 'electronic' то электронный тип, иначе наличные
        typeOfPayment: typeOfPayment,

        //номер устройствва
        numDevice: this.kkmNumDevice,
        //название компании
        companyName: this.shop.legal_name,
        //имя кассира
        cashierName: this.authenticatedUser.name,
        // ИНН продавца Тег ОФД 1203
        cashierINN: this.authenticatedUser.inn, //"430601071197",

        // Тип чека, Тег 1054;
        // 0 – продажа/приход;                      10 – покупка/расход;
        // 1 – возврат продажи/прихода;             11 - возврат покупки/расхода;
        // 2 – корректировка продажи/прихода;       12 – корректировка покупки/расхода;
        receiptType: receiptType,

        // Номер чека для эквайринга
        receiptNumber: receiptNumber,

        // ИНН ККМ для поиска. Если "" то перове не блокированное на сервере
        InnKkm: this.receipts_settings.inn ? this.receipts_settings.inn : "",

        // RRNCode из операции эквайринга. Только для отмены оплаты! Для Оплаты или возврата оплаты не заполнять!
        RRNCode: "",
        // AuthorizationCode из операции эквайринга. Только для отмены оплаты! Для Оплаты или возврата оплаты не заполнять!
        authorizationCode: "",

        // НДС в процентах или ТЕГ НДС: 0 (НДС 0%), 10 (НДС 10%), 20 (НДС 20%), -1 (НДС не облагается), 120 (НДС 20 /120), 110 (НДС 10 /110), Тег 1043, Из нее расчет тега 1079
        tax: this.receipts_settings.nds,
      };
      let sum = parseFloat(order.total_sum).toFixed(2);
      let receiptLines = [];
      for (let i in order.items) {
        let good_name = order.items[i].name;
        let brand = order.items[i].brand ? order.items[i].brand : "";
        let part_number = order.items[i].part_number
          ? order.items[i].part_number
          : "";

        // Признак предмета расчета. тег ОФД 1212. Для ФФД.1.05 и выше обязательное поле
        let sign_calculation_object = 1; //1 - Товар; 3 - Услуга
        switch (order.items[i]) {
          case "repairtime":
            sign_calculation_object = 3; //услуга
            break;
          case "part":
            sign_calculation_object = 1; //товар
            break;
        }

        receiptLines.push(
          // Строка с печатью фискальной строки
          {
            Register: {
              // Наименование товара 64 символа, Тег 1059
              Name: good_name + " " + brand + " " + part_number,
              // Количество товара (3 знака после запятой), Тег 1023
              Quantity: order.items[i].amount,
              // Цена за шт. без скидки (2 знака после запятой)
              Price: order.items[i].price,
              // Конечная сумма строки с учетом всех скидок /наценок; (2 знака после запятой), Из нее расчет тега 1079
              Amount: parseFloat(
                order.items[i].price * order.items[i].amount
              ).toFixed(2),
              // Отдел, по которому ведется продажа
              Department: 0,
              // НДС в процентах или ТЕГ НДС: 0 (НДС 0%), 10 (НДС 10%), 20 (НДС 20%), -1 (НДС не облагается), 120 (НДС 20 /120), 110 (НДС 10 /110), Тег 1043, Из нее расчет тега 1079
              Tax: options.tax, //20,
              // Признак способа расчета. тег ОФД 1214. Для ФФД.1.05 и выше обязательное поле
              SignMethodCalculation: 4, //4 - полный расчет
              // Признак предмета расчета. тег ОФД 1212. Для ФФД.1.05 и выше обязательное поле
              SignCalculationObject: sign_calculation_object, //1 - Товар; 3 - Услуга
              // // Цифровой код страны происхождения товара в соответствии с Общероссийским классификатором стран мира 3 симв. Тег 1230
              // CountryOfOrigin: "156",
              // // Регистрационный номер таможенной декларации 32 симв. Тег 1231
              // CustomsDeclaration: "54180656/1345865/3435625/23",
              // Сумма акциза с учетом копеек, включенная в стоимость предмета расчета Тег 1229
              ExciseAmount: null, // Иначе сумма акциза
            },
          }
        );
      }
      await this.printReceipt(
        this.kkmNumDevice,
        typeOfPayment,
        receiptType,
        receiptNumber,
        options,
        receiptLines,
        sum,
        order.id
      );
    },

    /**
     *
     * @param numDevice - номер ККМ
     * @param typeOfPayment - тип платежа "cash" | "electronic"
     * @param receiptType - тип чека
     * @param receiptNumber - номер чека
     * @param options - араметры чека
     * @param receiptLines - позиции в чеке
     * @param sum - сумма
     * @param orderId - Id заказа
     * @param receiptIdForCancel - ID чека для которого данный является чеком отмены
     * @returns {Promise<void>}
     */
    async printReceipt(
      numDevice,
      typeOfPayment,
      receiptType,
      receiptNumber,
      options,
      receiptLines,
      sum,
      orderId,
      receiptIdForCancel = null
    ) {
      let payWithCardData = {
        cardPaymentData: null,
      };

      if (
        !(await this.checkAvailabilityReceiptPrint(
          numDevice,
          orderId,
          receiptType,
          options.InnKkm
        ))
      ) {
        return;
      }

      if (receiptType === 0 && typeOfPayment === "electronic") {
        payWithCardData = await this.payWithCard(receiptNumber, sum);
        if (!payWithCardData.result) return;
      }

      //отмена платежа по карте
      if (receiptType === 1 && typeOfPayment === "electronic") {
        let returnPaymentResult;
        returnPaymentResult = await this.returnPaymentWithCard(sum, options);
        if (!returnPaymentResult) return;
      }

      this.$store
        .dispatch("receipts/store", {
          order_id: this.order.id,
          receipt_lines: receiptLines,
          options: options,
          receipt_type: receiptType,
          card_payment_data: payWithCardData.cardPaymentData,
          sum: sum,
          type_of_payment: typeOfPayment,
          it_is_cancel_for_receipt_with_id: receiptIdForCancel,
        })
        .then((receipt) => {
          this.getReceipts();
          if (receipt && receipt.options) {
            KKMPrintReceipt(
              receiptLines,
              receipt.options,
              (res) => {
                //успешно распечатанный чек
              },
              (error) => {
                this.$store.dispatch("common/showError", { error });
              }
            );
          }
        });
    },

    /**
     * Проверка доступности ККМ
     * @param numDevice
     * @param orderId
     * @param receiptType
     * @param INN - ИНН устройства
     * @returns {Promise<boolean>}
     */
    async checkAvailabilityReceiptPrint(numDevice, orderId, receiptType, INN) {
      if (INN === null) INN = "";
      if (!window.KkmServer) {
        this.$error("KKMServer plugin didn't installed in current browser!");
        return;
      }

      if (this.receipts_settings === null && this.fetched) {
        this.$error("Не установлены параметры для ККМ!");
        return;
      }
      let deviceAvailableCheck = new Promise(function (resolve, reject) {
        KKMGetDataKKT(numDevice, INN, resolve, reject);
      });

      let deviceIsAvailable = false;
      await deviceAvailableCheck
        .then((res) => {
          if (res.Info.InnOrganization !== INN) {
            throw (
              "Wrong INN: '" +
              res.Info.InnOrganization +
              "' not equals '" +
              INN +
              "'"
            );
          }
          deviceIsAvailable = true;
        })
        .catch((err) => {
          this.$error(err);
          deviceIsAvailable = false;
        });
      if (!deviceIsAvailable) return false;
      //проверим что мы можем печатать такой чек
      let isAvailible = false;
      await this.$store
        .dispatch("receipts/checkAvailabilityReceipt", {
          order_id: orderId,
          receipt_type: receiptType,
        })
        .then((result) => {
          isAvailible = result;
        });

      if (!isAvailible) return false;
      return true;
    },

    /**
     * Платеж с помощью карты
     * @param numDevice
     * @param sum
     * @returns {Promise<{result: boolean, cardPaymentData: {}}>}
     */
    async payWithCard(receiptNumber, sum) {
      let numDevice = 0;
      let doPayWithCard = new Promise((resolve) => {
        let Data = {
          // Команда серверу
          Command: "PayByPaymentCard",
          // Номер устройства. Если 0 то первое не блокированное на сервере
          NumDevice: numDevice,
          // Номер Карты / Данные карты - если карта считывается устройством то не заполняется
          //CardNumber: "",
          // Сумма оплаты
          Amount: sum,
          // Номер чека
          ReceiptNumber: receiptNumber,
        };
        KKMPayByPaymentCard(Data, resolve);
      });

      return await doPayWithCard.then((data) => {
        let isSuccessPayedWithCard = false;
        let cardPaymentData = {};
        if (data && data.Status !== 0) {
          isSuccessPayedWithCard = false;
          this.$error(data.Error);
        } else {
          isSuccessPayedWithCard = true;
          cardPaymentData = data;
        }
        return {
          result: isSuccessPayedWithCard,
          cardPaymentData: cardPaymentData,
        };
      });
    },

    /**
     * Отмена платежа по платежной карте
     * @param Amount
     * @param options
     * @returns {Promise<boolean>}
     */
    async returnPaymentWithCard(Amount, options) {
      let numDevice = 0;
      let doReturnPaymentWithCard = new Promise((resolve) => {
        // Отменить платеж по платежной карте --------------------------------------------------------------------
        // Подготовка данных команды
        let Data = {
          // Команда серверу
          Command: "CancelPaymentByPaymentCard",
          // Номер устройства. Если 0 то первое не блокированное на сервере
          NumDevice: numDevice,
          // Номер Карты / Данные карты - если карта считывается устройством то не заполняется
          CardNumber: options.CardNumber,
          // Сумма оплаты
          Amount: Amount,
          // Номер чека
          ReceiptNumber: options.ReceiptNumber,
          // Уникальный код транзакции RRN который был получен при оплате картой
          RRNCode: options.RRNCode,
          // Код авторизации транзакции который был получен при оплате картой
          AuthorizationCode: options.AuthorizationCode,
        };
        KKMCancelPaymentByPaymentCard(Data, resolve, (error) => {
          this.$error(error);
        });
      });

      return await doReturnPaymentWithCard.then((data) => {
        let isSuccess;
        if (data && data.Status !== 0) {
          isSuccess = false;
          this.$error(data.Error);
        } else {
          isSuccess = true;
        }
        return isSuccess;
      });
    },

    loadData(){
      this.$store
          .dispatch("orders/orderPresentedGet", {
            id: this.orderId,
            presenter: this.presenter, //OrderConcatenatedRepairtimesWithParts
          })
          .then(() => {
            //KKMListDevices();
            this.$store.dispatch("receipts_settings/get");
            this.getReceipts();
          });
    }
  },
  computed: {
    ...mapFields("orders", {
      order: "orderPresented",
      orderFetched: "fetched",
    }),
    ...mapFields("bid_stages", { bidsStagesIsFetched: "fetched" }),
    ...mapFields("auth", ["authenticated", "authenticatedUser", "isFetching"]),
    ...mapFields("receipts_settings", ["receipts_settings", "fetched"]),
    ...mapFields("receipts", [
      "fetched",
      "savingInProgress",
      "isLoading",
      "receipts",
      "hasError",
    ]),
    isOrderStatusRightForPrintReceipt() {
      return (
        this.order &&
        this.order.status &&
        this.order.status.system &&
        this.order.status.name === this.canPrintWithStatus
      );
    },
    shop() {
      return this.authenticatedUser.shop;
    },
    showWindow: {
      get() {
        return this.show;
      },
      set() {
        this.$emit("hide");
      },
    },
  },
  mounted() {},

  watch: {
    show(to) {
      if (to) {
        this.loadData()
      }
    },
  },
};
</script>
